export default "__VITE_ASSET__2b529320__"